import axiosInstance from "app/axiosInstance";

/**
 * Report generation (`POST /reports`) is latency-sensitive: time-to-first-byte and
 * payload size are dominated by the API. To diagnose slowness, use DevTools
 * Network (Waiting vs Content Download) and server-side traces for the given
 * `reportType` (e.g. working hours = 3). Client-side work happens after the response.
 * Improving perceived speed for large accounts usually requires API-side query tuning,
 * indexes, or async generation for heavy report types.
 */
class ReportsService {
  static generateReport = async (data: any, signal?: AbortSignal) => {
    return await axiosInstance.post(
      `/reports`,
      {
        ...data,
        shouldNotResolveAddresses: true
      },
      signal ? { signal } : undefined
    );
  };

  static listXarReport = async (data: any) => {
    return await axiosInstance.post(`/reports/xar`, {
      ...data
    });
  };

  static generateXarReport = async (data: any) => {
    return await axiosInstance.post(`/reports/xar/generate`, {
      ...data
    });
  };

  static downloadXarReport = async (data: any) => {
    return await axiosInstance.post(
      `/reports/xar/download`,
      {
        ...data
      },
      {
        responseType: "arraybuffer"
      }
    );
  };

  static exportReport = async (data: any) => {
    return await axiosInstance.post(`/reports/export`, {
      ...data
    });
  };
}

export default ReportsService;
